import api from './api';

export function getActiveCouponByCode(code) {
    return api.get(`/coupons/available/${code}`);
}

export function getCouponByCode(code, event_id) {
    return api.get(`/coupon/code/${code}/${event_id}`);
}

export function deleteCouponById(id) {
    return api.delete(`/coupon/${id}`);
}

export function updateVoucher(event_id, coupo_code){
    return api.patch(`coupon/${coupo_code}/event/${event_id}`)
}

export function getActiveCouponInter(event_id) {
    return api.get(`/coupons/available/inter/${event_id}`);
}
